/**
 * Frontend Popup Settings Hook
 *
 * Hook for accessing plugin settings in the frontend popup.
 *
 * @since 1.0.0
 */

import type { RedFoxPopupSettings } from './types';

/**
 * Hook to get popup settings from global window object
 *
 * @since 1.0.0
 *
 * @return Popup settings
 */
export const usePopupSettings = (): RedFoxPopupSettings => {
  const settings = (window.redfoxAddedToCartPopup?.settings ?? {}) as RedFoxPopupSettings;

  return settings;
};
